import React, { useState } from 'react'
import CIcon from '@coreui/icons-react'
import {
  CAlert, CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CSpinner
} from '@coreui/react'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function Login(){
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const { login } = useAuth()
  const history = useHistory()

  async function handleLogin() {
    setError('')
    setLoading(true)

    if (!email || !password) {
      setError('Please enter email and password')
      setLoading(false)
      return;
    }

    try {
      await login(email, password)
      history.push('/')
    } catch (error) {
      setError(error.message)
    }

    setLoading(false)
  }

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="5">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm onSubmit={(e) => {
                    e.preventDefault()
                    handleLogin()
                  }} type="post">
                    <h2>Login</h2>
                    <p className="text-muted">Sign In to your account</p>
                    {error && <CAlert color="danger">{error}</CAlert>}
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-user" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" autoComplete="email" />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Password" autoComplete="current-password" />
                    </CInputGroup>
                    <CRow className="text-right">
                      <CCol xs="12">
                        <CButton disabled={loading} color="dark" className="px-4 w-100"
                          type="submit"
                          onClick={handleLogin} >
                          {
                            loading ? (<><CSpinner component="span" size="sm" aria-hidden="true" /> Loading...</>) : 'Login'
                          }
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
